var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItni(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 40,
    viewBox: "0 0 108 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.150391 0.000976562H12.0254V40.001H0.150391V0.000976562ZM26.4004 0.000976562H15.7754V10.001H26.4004V40.001H38.2754V10.001H49.7744V0.000976562H38.2754H26.4004ZM77.6504 40.001H80.1504H90.165H90.3994V0.000976562H80.1504V22.7213L67.123 0.155396V0.000976562H63.9004H52.6504V15.001V40.001H63.9004V15.0327L77.6504 40.001ZM107.65 0.000976562H96.4004V40.001H107.65V0.000976562Z",
    fill: "#3D8999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItni);
export default __webpack_public_path__ + "static/media/ITNI.d07f370c89f9c36cf55c95514453957d.svg";
export { ForwardRef as ReactComponent };